import React, { useState } from "react";
import { Col, Row, Input, Space, Upload, message, Form } from "antd";
import { Domain, request } from "../../../../config/API";
import { PlusOutlined } from "@ant-design/icons";
import shortId from "shortid";
import ImgCrop from "antd-img-crop";
import imageCompression from "browser-image-compression";
import getBase64 from "../../../../helpers/getBase64";
import authHeader from "../../../../redux/services/authHeader";

import { COLORS } from "../../../../config/theme";

import "./Theme.css";
import PreviewImage from "./PreviewImage";
import { InputColor } from "./InputColor";

const { primaryDark, primary } = COLORS;

const Theme = ({ form }) => {
  const [togglePicker, setTogglePicker] = useState(false);
  const [togglePicker1, setTogglePicker1] = useState(false);

  const [bgImageList, setBgImageList] = useState([]);

  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  const controller = new AbortController();
  const options = {
    signal: controller.signal,
    maxSizeMB: 1,
  };

  const postBgImage = ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("bgImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              ...authHeader(),
            },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const bgImage = {
              uid: shortId(),
              name: data.bgImage,
              status: "done",
              url: Domain + "/data/" + data.bgImage,
            };

            setBgImageList([...bgImageList, bgImage]);

            form.setFieldValue(
              "bgImage",
              (bgImage?.name ? bgImage?.name : null) ||
                (bgImage ? bgImage : null)
            );
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
          });
        return;
      })
      .catch(function (error) {
        console.error(error.message);
      });
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  return (
    <>
      <span
        onClick={() => {
          setTogglePicker(false);
          setTogglePicker1(false);
        }}
      >
        <h3> Background Colors</h3>

        <Row gutter={10} style={{ marginTop: 24, width: "25rem" }}>
          <Col span={4}>
            <h4>Presets</h4>
          </Col>
          <Col span={20}>
            <Space className="color-selection-containter">
              <div className="color-selection-subContainter">
                <div
                  className="color-selection-box"
                  onClick={() => {
                    form.setFieldValue("pColor", primary);
                    form.setFieldValue("sColor", primaryDark);
                  }}
                >
                  <div className="top" style={{ background: primary }} />
                  <div className="bottom" style={{ background: primaryDark }} />
                </div>
                <div
                  className="color-selection-box"
                  onClick={() => {
                    form.setFieldValue("pColor", "#E7A14A");
                    form.setFieldValue("sColor", "#10171E");
                  }}
                >
                  <div className="top" style={{ background: "#E7A14A" }} />
                  <div className="bottom" style={{ background: "#10171E" }} />
                </div>
              </div>
              <div className="color-selection-subContainter">
                <div
                  className="color-selection-box"
                  onClick={() => {
                    form.setFieldValue("pColor", "#333333");
                    form.setFieldValue("sColor", "#ED6363");
                  }}
                >
                  <div className="top" style={{ background: "#333333" }} />
                  <div className="bottom" style={{ background: "#ED6363" }} />
                </div>
                <div
                  className="color-selection-box"
                  onClick={() => {
                    form.setFieldValue("pColor", "#CEB996");
                    form.setFieldValue("sColor", "#322F44");
                  }}
                >
                  <div className="top" style={{ background: "#CEB996" }} />
                  <div className="bottom" style={{ background: "#322F44" }} />
                </div>
              </div>
            </Space>
          </Col>
        </Row>

        {/* color picker */}
        <Row
          gutter={10}
          style={{
            marginTop: 24,
            width: "25rem",
            alignItems: "center",
          }}
        >
          <Col span={4} style={{ alignSelf: "baseline" }}>
            <h4>Select Colors</h4>
          </Col>
          <Col className="colorPickerContainer" span={20}>
            <Col
              span={11}
              style={{
                marginBottom: ".5rem",
              }}
            >
              <Form.Item name="pColor">
                <InputColor
                  togglePicker={togglePicker}
                  placeholder="#1890ff"
                  onClick={(e) => {
                    e.stopPropagation();
                    setTogglePicker(!togglePicker);
                  }}
                ></InputColor>
              </Form.Item>
            </Col>
            <Col
              span={11}
              style={{
                marginBottom: ".5rem",
              }}
            >
              <Form.Item name="sColor">
                <InputColor
                  togglePicker={togglePicker1}
                  placeholder="#001529"
                  onClick={(e) => {
                    e.stopPropagation();
                    setTogglePicker1(!togglePicker1);
                  }}
                ></InputColor>
              </Form.Item>
            </Col>
          </Col>
        </Row>

        {/* background image */}
        <Row gutter={10} style={{ marginTop: 24 }}>
          <Col>
            <h4>Background Image</h4>
            <p className="subText">Size: 500 KB</p>
            <p className="subText">Dimension: 550 x 300 px </p>
            <p className="subText">Max Dimensions: 1024 x 1024 px </p>
          </Col>
          <Col>
            <ImgCrop
              rotate
              quality={1}
              modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
              minZoom={1}
              maxZoom={10}
              aspect={2 / 1}
              modalWidth={530}
              fillColor="#00000000"
            >
              <Upload
                className="fileList-upload-images"
                maxCount={1}
                customRequest={postBgImage}
                listType="picture-card"
                fileList={bgImageList}
                onPreview={handlePreview}
                onRemove={() => {
                  form.setFieldValue("bgImage", "");
                }}
                onChange={(e) => {
                  setBgImageList(
                    bgImageList.filter((f) => f.uid !== e?.file?.uid)
                  );
                }}
                accept="image/*"
              >
                {bgImageList.length === 1 ? null : <PlusOutlined />}
              </Upload>
            </ImgCrop>
          </Col>
        </Row>
      </span>
      <Form.Item name="bgImage">
        <Input type="hidden"></Input>
      </Form.Item>
      <PreviewImage
        previewImage={previewImage}
        previewVisible={previewVisible}
        setPreviewVisible={setPreviewVisible}
      ></PreviewImage>
    </>
  );
};

export default Theme;
